import { createContext, useState } from 'react';
import { useQuery } from 'react-query';
import { PurchaseOrderApi } from 'api';
import { useQueryDropdown } from 'config/useQueryDropdown';

export const DropdownPurchaseOrderContext = createContext();

export const DropdownPurchaseOrderContextProvider = ({ children }) => {
  const dropdownMenuKey = 'purchase_order';

  const dropdownApproval = [
    { value: 'PEN', label: 'PENDING' },
    { value: 'REV', label: 'REVISE' },
    { value: 'VER', label: 'VERIFIED' },
    { value: 'APP', label: 'APPROVED' },
    { value: 'REJ', label: 'REJECTED' },
  ];

  const dropdownStatusPO = [
    { value: 'open', label: 'OPEN' },
    { value: 'close', label: 'CLOSED' },
  ];

  const [dropdownPembayaran, setDropdownPembayaran] = useState([
    { value: 'CASH', label: 'CASH' },
    {
      value: '7 HARI DARI TANDA TERIMA NOTA / INVOICE',
      label: '7 HARI DARI TANDA TERIMA NOTA / INVOICE',
    },
    {
      value: '14 HARI DARI TANDA TERIMA NOTA / INVOICE',
      label: '14 HARI DARI TANDA TERIMA NOTA / INVOICE',
    },
    {
      value: '30 HARI DARI TANDA TERIMA NOTA / INVOICE',
      label: '30 HARI DARI TANDA TERIMA NOTA / INVOICE',
    },
  ]);

  const dropdownJabatan = useQuery(
    ['dropdown', 'jabatan', dropdownMenuKey],
    () =>
      PurchaseOrderApi.getDropdown({ tipe: 'jabatan' }).then((res) =>
        res.data.data.map((k) => ({
          value: k.id_jabatan,
          label: k.nama_jabatan,
        }))
      )
  );

  const useDropdownKaryawan = (id_jabatan) =>
    useQuery(['dropdown', 'karyawan', dropdownMenuKey, id_jabatan], () =>
      PurchaseOrderApi.getDropdown({ tipe: 'karyawan', id_jabatan }).then(
        (res) =>
          res.data.data.map((k) => ({
            value: k.id_karyawan,
            label: k.nama_karyawan,
          }))
      )
    );

  const dropdownItem = useQuery(
    ['dropdown', 'item', dropdownMenuKey],
    () =>
      PurchaseOrderApi.getDropdown({ tipe: 'item' }).then((res) =>
        res.data.data.map((k) => ({
          value: k.id_item_buaso,
          label: k.nama_item,
        }))
      ),
    useQueryDropdown
  );

  const dropdownVendor = useQuery(
    ['dropdown', 'vendor', dropdownMenuKey],
    () =>
      PurchaseOrderApi.getDropdown({ tipe: 'vendor' }).then((res) =>
        res.data.data.map((k) => ({ value: k.id_vendor, label: k.nama_vendor }))
      ),
    useQueryDropdown
  );

  return (
    <DropdownPurchaseOrderContext.Provider
      value={{
        dropdownApproval,
        dropdownStatusPO,
        dropdownPembayaran,
        setDropdownPembayaran,
        dropdownJabatan,
        useDropdownKaryawan,
        dropdownItem,
        dropdownVendor,
      }}
    >
      {children}
    </DropdownPurchaseOrderContext.Provider>
  );
};

export const withDropdownPurchaseOrderContextProvider =
  (Component) => (props) => {
    return (
      <DropdownPurchaseOrderContextProvider>
        <Component {...props} />
      </DropdownPurchaseOrderContextProvider>
    );
  };
